



































import TableActionDropdown from '@/components/TableActionDropdown.vue';
import { ModuleResponseDTO } from '@/jbi-shared/dto/jtms.dtos';
import { ModuleStatus } from '@/jbi-shared/types/jtms.types';
import { capitalize } from '@/jbi-shared/util/string.utils';
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

@Component({
  components: {
    TableActionDropdown
  }
})
export default class ModuleRow extends Vue {
  @Prop() module!: ModuleResponseDTO;

  get capitalizedStatus() {
    return capitalize(this.module.status.toLowerCase());
  }

  get isActive() {
    return this.module.status === ModuleStatus.ACTIVE;
  }

  get isArchived() {
    return this.module.status === ModuleStatus.ARCHIVED;
  }

  @Emit('activate')
  emitActivateEvent() {
    return this.module;
  }

  @Emit('archive')
  emitArchiveEvent() {
    return this.module;
  }
}
